/* unplugin-vue-components disabled */import __unplugin_components_2 from 'D:/htdocs/gitlab_project/laravel/mukiPailung/frontend/src/components/form/BaseCalendar.vue';
import __unplugin_components_1 from 'D:/htdocs/gitlab_project/laravel/mukiPailung/frontend/src/components/CompanyCard.vue';
import __unplugin_components_0 from 'D:/htdocs/gitlab_project/laravel/mukiPailung/frontend/src/components/form/HomeBaseInput.vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a6d776e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-bar"
};
const _hoisted_2 = {
  class: "home-list"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "specification-input-wrap"
};
import { useI18n } from "vue-i18n";
import { useStore } from 'vuex';
import { baseGet, basePost, ServiceSales, Staff, OfflineDS } from "@/js/services/baseService";
import { ajax200Res } from '@/js/utils';
// import store from "@/store/store.js";

export default {
  __name: 'Home',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n();
    const staffPermissions = localStorage.getItem('staffPermissions');
    const cData = reactive({
      list: [],
      title: ''
    });

    // store
    const store = useStore();

    // auth
    const authInfo = store.getters['auth/authInfo'];
    const staffInfoData = store.getters['staffInfo'];
    const datepicker = ref(null);
    const openCalendar = () => {
      datepicker.value.$el.querySelector('input').click();
    };
    const calendar = reactive({
      date: [],
      calendarParams: {
        rangePicker: true
      }
    });
    const filter = reactive({
      isOpened: false,
      status: [],
      specification_one: '',
      specification_two: '',
      specification_three: '',
      specification_g: '',
      specification_f: '',
      specification_t: ''
    });
    const filterReset = () => {
      filter.status = [];
      filter.specification_one = '';
      filter.specification_two = '';
      filter.specification_three = '';
      filter.specification_g = '';
      filter.specification_f = '';
      filter.specification_t = '';
    };
    const changeStatus = e => {
      const value = e.target.value;
      const list = filter.status;
      if (e.target.checked) {
        list.push(value);
      } else {
        list.splice(list.indexOf(value), 1);
      }
    };

    // 重新取得員工資料
    const reLoadStaff = () => {
      if (authInfo.offLine) {
        _get_variable("staff").then(res => {
          if (res.res_code == 1) {
            const member_id = res.res_content;
            const tidySql = apiTidy("getStaff", {
              'id': member_id
            });
            _selectSQLite(tidySql).then(data => {
              let sqlData = JSON.parse(data.resData);
              const memberData = sqlData[0];
              localStorage.setItem('staffPermissions', [1]);
              localStorage.setItem('staffName', memberData.name);
              localStorage.setItem('staffCode', memberData.code);
              let staff = {
                id: memberData.id,
                name: memberData.name,
                code: memberData.code,
                ordersPermission: 1,
                muPermission: 0,
                partitionID: memberData.partition_id
              };
              store.commit('updateStaff', staff);
              f7.panel.open();
            });
          }
        });
      } else {
        Staff.getInfo().then(res => {
          const {
            onSuccess,
            onFail
          } = ajax200Res(res);
          onSuccess(({
            res,
            data,
            msg,
            defaultAlert
          }) => {
            localStorage.setItem('staffPermissions', data.content.permissions);
            localStorage.setItem('staffName', data.content.name);
            localStorage.setItem('staffCode', data.content.code);
            let staff = {
              id: data.content.id,
              name: data.content.name,
              code: data.content.code,
              ordersPermission: data.content.permissions.includes(1),
              muPermission: data.content.permissions.includes(2)
            };
            store.commit('updateStaff', staff);
            f7.panel.open();
          });
          onFail(({
            res,
            data,
            msg,
            defaultAlert
          }) => {});
        });
      }
    };
    const searchBadge = reactive({
      calendar: false,
      filter: false
    });
    const init = () => {
      // var sss = [1,2,3,4];
      // var bbb = "as";
      // console.log('sss type',typeof(sss));
      // console.log('bbb type',typeof(bbb));
      let sendData = {
        'keyword': cData.title,
        'dates': calendar.date,
        'status': filter.status,
        'specification_one': filter.specification_one,
        'specification_two': filter.specification_two,
        'specification_three': filter.specification_three,
        'specification_g': filter.specification_g,
        'specification_f': filter.specification_f,
        'specification_t': filter.specification_t
      };
      if (sendData.status.length > 0 || sendData.specification_one != '' || sendData.specification_two != '' || sendData.specification_three != '' || sendData.specification_g != '' || sendData.specification_f != '' || sendData.specification_t != '') {
        searchBadge.filter = true;
      } else {
        searchBadge.filter = false;
      }
      if (calendar.date.length > 0) {
        searchBadge.calendar = true;
      } else {
        searchBadge.calendar = false;
      }
      if (authInfo.offLine) {
        _loading_start();
        const tidySql = apiTidy("getServiceSales", sendData);
        console.log('calendar.date', calendar.date);
        console.log('tidySql', tidySql);
        _selectSQLite(tidySql).then(data => {
          var otherList = [];
          var statusMobileToDbMap = {
            "1": "process",
            "2": "finish",
            "3": "wait"
          };
          const sqlData = JSON.parse(data.resData);
          // 整理DATA
          $.each(sqlData, function (index, item) {
            const singleItem = {
              "index": index + 1,
              "close_the_case": item.close_the_case,
              "name": item.customer_name,
              "serviceSaleID": parseInt(item.id),
              "serviceSalesNumber": item.service_sales_number == "offlinenew" ? t('onlineGenerate') : item.service_sales_number,
              "subCount": item.machines_count,
              "type": statusMobileToDbMap[item.sales_status]
            };
            otherList.push(singleItem);
          });
          console.log('otherList', otherList);
          cData.list = otherList;
          _loading_stop();
        });
      } else {
        if (!staffPermissions) {
          m_back_page('/login');
        }

        // 取得售服單列表
        ServiceSales.getServiceSales(sendData).then(res => {
          const {
            onSuccess,
            onFail
          } = ajax200Res(res);
          onSuccess(({
            res,
            data,
            msg,
            defaultAlert
          }) => {
            cData.list = data.content.otherList;
          });
          onFail(({
            res,
            data,
            msg,
            defaultAlert
          }) => {
            if (data.result_code == -1) {
              m_back_page('/login');
            }
          });
        });
      }
    };
    const staffInfo = () => {
      if (authInfo.offLine) {
        _get_variable("staff").then(res => {
          if (res.res_code == 1) {
            const member_id = res.res_content;
            const tidySql = apiTidy("getStaff", {
              'id': member_id
            });
            _selectSQLite(tidySql).then(data => {
              let sqlData = JSON.parse(data.resData);
              const memberData = sqlData[0];
              localStorage.setItem('staffPermissions', [1]);
              localStorage.setItem('staffName', memberData.name);
              localStorage.setItem('staffCode', memberData.code);
              let staff = {
                id: memberData.id,
                name: memberData.name,
                code: memberData.code,
                ordersPermission: 1,
                muPermission: 0,
                partitionID: memberData.partition_id
              };
              store.commit('updateStaff', staff);
              init();
            });
          }
        });
      } else {
        Staff.getInfo().then(res => {
          const {
            onSuccess,
            onFail
          } = ajax200Res(res);
          onSuccess(({
            res,
            data,
            msg,
            defaultAlert
          }) => {
            console.log('member data', data.content);
            localStorage.setItem('staffPermissions', data.content.permissions);
            localStorage.setItem('staffName', data.content.name);
            localStorage.setItem('staffCode', data.content.code);
            let staff = {
              id: data.content.id,
              partitionID: data.content.partition_id,
              name: data.content.name,
              code: data.content.code,
              ordersPermission: data.content.permissions.includes(1),
              muPermission: data.content.permissions.includes(2)
            };
            store.commit('updateStaff', staff);
            init();
          });
          onFail(({
            res,
            data,
            msg,
            defaultAlert
          }) => {
            m_back_page('/login');
          });
        });
      }
    };
    setTimeout(function () {
      staffInfo();
    }, 200);
    const focusNextInput = e => {
      if (e.target.value !== '' && e.target.value.length == e.target.maxLength) {
        const nextInput = e.target.nextElementSibling;
        if (nextInput) {
          nextInput.focus();
          return;
        }
        let parent = e.target.parentNode;
        if (parent.nextSibling && parent.nextSibling.firstChild) {
          parent.nextSibling.firstChild.focus();
        }
      }
    };
    const synchronizeData = () => {
      if (authInfo.offLine) {
        _alert_custom(t('hint'), t('needOnline'), function () {});
      } else {
        _transfer_variable("staff", staffInfoData.id).then(res => {});
        var syncDateTime = "";
        var syncStep = {
          'Upload': true,
          'UploadFile': true,
          'File': true,
          'DBData': true,
          'DBImageFile': true
        };
        var copyUrlImage = [];
        var fileDB = ['service_sale_cuatomer_feedbacks', 'service_sale_cuatomer_feedback_files', 'service_machine_arrangement_file', 'service_machine_course_plan_files', 'service_machine_problem_time_files'];
        var stepCount = 0;
        var progressOneStep = 0;
        var progress = 0;
        var dialogProgress;
        var oriDialogProgressText = '';
        var dialogProgressIng;
        var ProgressText = '';
        var selectItem;
        var version = "1.0.3";
        var downloadFileList = [];
        var uploadList = {
          'service_sales': [],
          'service_sale_times': [],
          'service_sale_staffs': [],
          'service_sale_cuatomer_feedbacks': [],
          'service_sale_cuatomer_feedback_files': [],
          'service_machines': [],
          'service_machine_statuses': [],
          'service_machine_staff': [],
          'service_machine_others': [],
          'service_machine_fittings': [],
          'service_machine_course_times': [],
          'service_machine_course_students': [],
          'service_machine_course_plans': [],
          'service_machine_course_plan_files': [],
          'service_machine_problems': [],
          'service_machine_problem_times': [],
          'service_machine_problem_time_files': [],
          'service_machine_basics': [],
          'service_machine_basic_yarns': [],
          'service_machine_basic_feeders': [],
          'service_machine_arrangements': [],
          'service_machine_arrangement_other': [],
          'service_machine_arrangement_file': []
        };

        // setTimeout((()=>{
        //     _progressDialogStart(ProgressText,t('synchronizeData'));
        // }), 1000);

        _get_variable("synchronizeTime").then(data => {
          if (data.res_code == 1) {
            syncDateTime = data.res_content;
            f7.dialog.create({
              title: t('synchronizeSelect'),
              buttons: [{
                text: t('cancel')
              }, {
                text: t('onlySynchronizeOffData')
              }, {
                text: t('synchronizeData')
              }],
              onClick: function (dialog, index) {
                if (index === 0) {
                  //Button 1 clicked
                } else if (index === 1) {
                  _confirm_custom(t('confirmDownload'), t('overwriteOffline'), function () {
                    syncStep["Upload"] = false;
                    syncStep["UploadFile"] = false;
                    selectItem = 1;
                    synchronize();
                  });
                } else if (index === 2) {
                  _confirm_custom(t('confirmSynchronization'), t('synchronizationOnline'), function () {
                    syncStep["Upload"] = true;
                    syncStep["UploadFile"] = true;
                    selectItem = 2;
                    synchronize();
                  });
                }
              },
              verticalButtons: true
            }).open();
          } else {
            syncStep["Upload"] = false;
            syncStep["UploadFile"] = false;
            synchronize();
          }
        });
        function synchronize() {
          if (selectItem == 1) {
            ProgressText = t('downloading');
            // dialogProgress = f7.dialog.progress(t('downloading'), progress);
          } else {
            ProgressText = t('synchronizing');
            // dialogProgress = f7.dialog.progress(t('synchronizing'), progress);
          }

          $.each(syncStep, function (key, value) {
            if (value) {
              stepCount += 1;
            }
          });
          progressOneStep = parseInt(100 / stepCount);
          if (syncStep["Upload"]) {
            _progressDialogStart(ProgressText, t('synchronizeData'));
            // dialogProgress.setProgress(progress);
            // dialogProgress.setText(t('synchronizeData'));
            // oriDialogProgressText = t('synchronizeData');
            // dialogProgresStart();
            _get_variable("synchronizeTime").then(data => {
              if (data.res_code == 1) {
                syncDateTime = data.res_content;
                setTimeout(() => {
                  DBUpLoad();
                }, 1000);
              } else {
                _progressDialogStart(ProgressText, t('downloadOfflineFile'));

                // progress += progressOneStep;
                // dialogProgress.setProgress(progress);
                // dialogProgress.setText(t('downloadOfflineFile'));
                // oriDialogProgressText = t('downloadOfflineFile');
                setTimeout(() => {
                  offLineFileUpdate();
                }, 1000);
              }
            });
          } else {
            _progressDialogStart(ProgressText, t('downloadOfflineFile'));

            // dialogProgress.setProgress(progress);
            // dialogProgress.setText(t('downloadOfflineFile'));
            // oriDialogProgressText = t('downloadOfflineFile');
            // dialogProgresStart();
            setTimeout(() => {
              offLineFileUpdate();
            }, 1000);
          }
        }

        // 離線檔案下載
        function offLineFileUpdate() {
          var synchronizeTimeResCode = 0;
          _get_variable("synchronizeTime").then(data => {
            synchronizeTimeResCode = data.res_code;
            _get_variable("synchronizeVersion").then(data => {
              if (synchronizeTimeResCode == 1 && data.res_content == version) {
                goDBData();
              } else {
                _offLineFileDownload().then(res => {
                  if (res.resCode == 1) {
                    goDBData();
                  } else {
                    synchronizeFail();
                  }
                });
              }
            });
          });
          function goDBData() {
            // _progressDialogStop();
            _progressDialogChange(1, 1);
            _progressDialogStart(ProgressText, t('downloadOfflineData'));
            _progressDialogChange(0, 33);
            // progress += progressOneStep;
            // dialogProgress.setProgress(progress);
            // dialogProgress.setText(t('downloadOfflineData'));
            // oriDialogProgressText = t('downloadOfflineData');
            DBData();
          }
        }

        // 同步DB資料
        function DBData() {
          var DBDataAll;
          _deleteSQLiteTabelAll().then(data => {
            _progressDialogChange(1, 33);
            _createSQLiteTabel(mukiConst.sql.staff);
            _createSQLiteTabel(mukiConst.sql.machineArrangements);
            _createSQLiteTabel(mukiConst.sql.machineQaCategories);
            _createSQLiteTabel(mukiConst.sql.machineQas);
            _createSQLiteTabel(mukiConst.sql.indexManages);
            _createSQLiteTabel(mukiConst.sql.annotations);
            _createSQLiteTabel(mukiConst.sql.serviceSales);
            _createSQLiteTabel(mukiConst.sql.serviceSaleTimes);
            _createSQLiteTabel(mukiConst.sql.serviceSaleStaffs);
            _createSQLiteTabel(mukiConst.sql.serviceSaleMaintenanceStaff);
            _createSQLiteTabel(mukiConst.sql.serviceSaleCuatomerFeedbacks);
            _createSQLiteTabel(mukiConst.sql.serviceSaleCuatomerFeedbackFiles);
            _createSQLiteTabel(mukiConst.sql.serviceMachines);
            _createSQLiteTabel(mukiConst.sql.serviceMachineStaff);
            _createSQLiteTabel(mukiConst.sql.serviceMachineBasics);
            _createSQLiteTabel(mukiConst.sql.serviceMachineBasicYarns);
            _createSQLiteTabel(mukiConst.sql.serviceMachineBasicFeeders);
            _createSQLiteTabel(mukiConst.sql.serviceMachineStatuses);
            _createSQLiteTabel(mukiConst.sql.serviceMachineFittings);
            _createSQLiteTabel(mukiConst.sql.serviceMachineOthers);
            _createSQLiteTabel(mukiConst.sql.serviceMachineProblems);
            _createSQLiteTabel(mukiConst.sql.serviceMachineProblemTimes);
            _createSQLiteTabel(mukiConst.sql.serviceMachineProblemTimeFiles);
            _createSQLiteTabel(mukiConst.sql.serviceMachineCoursePlans);
            _createSQLiteTabel(mukiConst.sql.serviceMachineCoursePlanFiles);
            _createSQLiteTabel(mukiConst.sql.serviceMachineCourseTimes);
            _createSQLiteTabel(mukiConst.sql.serviceMachineCourseStudents);
            _createSQLiteTabel(mukiConst.sql.serviceMachineArrangements);
            _createSQLiteTabel(mukiConst.sql.serviceMachineArrangementOther);
            _createSQLiteTabel(mukiConst.sql.serviceMachineArrangementFile);
            _progressDialogChange(2, 33);
            ServiceSales.getServiceSaleAll().then(res => {
              _progressDialogChange(3, 33);
              const {
                onSuccess,
                onFail
              } = ajax200Res(res);
              onSuccess(({
                res,
                data,
                msg,
                defaultAlert
              }) => {
                var processItemsDeferred = [];
                DBDataAll = data.content;
                $.each(data.content, function (index, value) {
                  if (fileDB.includes(index)) {
                    $.each(value, function (key1, value1) {
                      if (value1['file_path'] != '' && value1['file_path'] != null) {
                        var filePath = value1['file_path'];
                        var imageUrl = window.location.origin + window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/')) + value1['file_path'];

                        // var imageUrl = window.location.protocol + '//' + window.location.hostname + value1['file_path'];
                        var filePaths = filePath.substring(0, filePath.lastIndexOf("/"));
                        var fileName = filePath.substring(filePath.lastIndexOf("/") + 1);
                        const singleItem = {
                          'imageUrl': imageUrl,
                          'filePath': filePaths,
                          'fileName': fileName
                        };
                        copyUrlImage.push(singleItem);
                      }
                    });
                  }
                });
                insertDBData();
              });
              onFail(({
                res,
                data,
                msg,
                defaultAlert
              }) => {
                synchronizeFail();
              });
            });
          });
          function insertDBData() {
            _insertSQLite("staff", JSON.stringify(DBDataAll["staff"]), "T").then(data => {
              _progressDialogChange(4, 33);
              _insertSQLite("machine_arrangements", JSON.stringify(DBDataAll["machine_arrangements"]), "T").then(data => {
                _progressDialogChange(5, 33);
                _insertSQLite("machine_qa_categories", JSON.stringify(DBDataAll["machine_qa_categories"]), "T").then(data => {
                  _progressDialogChange(6, 33);
                  _insertSQLite("machine_qas", JSON.stringify(DBDataAll["machine_qas"]), "T").then(data => {
                    _progressDialogChange(7, 33);
                    _insertSQLite("index_manages", JSON.stringify(DBDataAll["index_manages"]), "T").then(data => {
                      _progressDialogChange(8, 33);
                      _insertSQLite("annotations", JSON.stringify(DBDataAll["annotations"]), "T").then(data => {
                        _progressDialogChange(9, 33);
                        _insertSQLite("service_sales", JSON.stringify(DBDataAll["service_sales"]), "T").then(data => {
                          _progressDialogChange(10, 33);
                          _insertSQLite("service_sale_times", JSON.stringify(DBDataAll["service_sale_times"]), "T").then(data => {
                            _progressDialogChange(11, 33);
                            _insertSQLite("service_sale_staffs", JSON.stringify(DBDataAll["service_sale_staffs"]), "T").then(data => {
                              _progressDialogChange(12, 33);
                              _insertSQLite("service_sale_maintenance_staff", JSON.stringify(DBDataAll["service_sale_maintenance_staff"]), "T").then(data => {
                                _progressDialogChange(13, 33);
                                _insertSQLite("service_sale_cuatomer_feedbacks", JSON.stringify(DBDataAll["service_sale_cuatomer_feedbacks"]), "T").then(data => {
                                  _progressDialogChange(14, 33);
                                  _insertSQLite("service_sale_cuatomer_feedback_files", JSON.stringify(DBDataAll["service_sale_cuatomer_feedback_files"]), "T").then(data => {
                                    _progressDialogChange(15, 33);
                                    _insertSQLite("service_machines", JSON.stringify(DBDataAll["service_machines"]), "T").then(data => {
                                      _progressDialogChange(16, 33);
                                      _insertSQLite("service_machine_statuses", JSON.stringify(DBDataAll["service_machine_statuses"]), "T").then(data => {
                                        _progressDialogChange(17, 33);
                                        _insertSQLite("service_machine_staff", JSON.stringify(DBDataAll["service_machine_staff"]), "T").then(data => {
                                          _progressDialogChange(18, 33);
                                          _insertSQLite("service_machine_others", JSON.stringify(DBDataAll["service_machine_others"]), "T").then(data => {
                                            _progressDialogChange(19, 33);
                                            _insertSQLite("service_machine_fittings", JSON.stringify(DBDataAll["service_machine_fittings"]), "T").then(data => {
                                              _progressDialogChange(20, 33);
                                              _insertSQLite("service_machine_course_times", JSON.stringify(DBDataAll["service_machine_course_times"]), "T").then(data => {
                                                _progressDialogChange(21, 33);
                                                _insertSQLite("service_machine_course_students", JSON.stringify(DBDataAll["service_machine_course_students"]), "T").then(data => {
                                                  _progressDialogChange(22, 33);
                                                  _insertSQLite("service_machine_course_plans", JSON.stringify(DBDataAll["service_machine_course_plans"]), "T").then(data => {
                                                    _progressDialogChange(23, 33);
                                                    _insertSQLite("service_machine_course_plan_files", JSON.stringify(DBDataAll["service_machine_course_plan_files"]), "T").then(data => {
                                                      _progressDialogChange(24, 33);
                                                      _insertSQLite("service_machine_problems", JSON.stringify(DBDataAll["service_machine_problems"]), "T").then(data => {
                                                        _progressDialogChange(25, 33);
                                                        _insertSQLite("service_machine_problem_times", JSON.stringify(DBDataAll["service_machine_problem_times"]), "T").then(data => {
                                                          _progressDialogChange(26, 33);
                                                          _insertSQLite("service_machine_problem_time_files", JSON.stringify(DBDataAll["service_machine_problem_time_files"]), "T").then(data => {
                                                            _progressDialogChange(27, 33);
                                                            _insertSQLite("service_machine_basics", JSON.stringify(DBDataAll["service_machine_basics"]), "T").then(data => {
                                                              console.log("service_machine_basic_yarns", JSON.stringify(DBDataAll["service_machine_basic_yarns"]));
                                                              _progressDialogChange(28, 33);
                                                              _insertSQLite("service_machine_basic_yarns", JSON.stringify(DBDataAll["service_machine_basic_yarns"]), "T").then(data => {
                                                                _progressDialogChange(29, 33);
                                                                _insertSQLite("service_machine_basic_feeders", JSON.stringify(DBDataAll["service_machine_basic_feeders"]), "T").then(data => {
                                                                  _progressDialogChange(30, 33);
                                                                  _insertSQLite("service_machine_arrangements", JSON.stringify(DBDataAll["service_machine_arrangements"]), "T").then(data => {
                                                                    _progressDialogChange(31, 33);
                                                                    _insertSQLite("service_machine_arrangement_other", JSON.stringify(DBDataAll["service_machine_arrangement_other"]), "T").then(data => {
                                                                      _progressDialogChange(32, 33);
                                                                      _insertSQLite("service_machine_arrangement_file", JSON.stringify(DBDataAll["service_machine_arrangement_file"]), "T").then(data => {
                                                                        _progressDialogChange(33, 33);
                                                                        _progressDialogStart(ProgressText, t('downloadOfflineImage'));
                                                                        // progress += progressOneStep;
                                                                        // dialogProgress.setProgress(progress);
                                                                        // dialogProgress.setText(t('downloadOfflineImage'));
                                                                        // oriDialogProgressText = t('downloadOfflineImage');
                                                                        DBImageFile();
                                                                      });
                                                                    });
                                                                  });
                                                                });
                                                              });
                                                            });
                                                          });
                                                        });
                                                      });
                                                    });
                                                  });
                                                });
                                              });
                                            });
                                          });
                                        });
                                      });
                                    });
                                  });
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          }
        }

        // 同步DB相關圖片
        function DBImageFile() {
          if (copyUrlImage.length > 0) {
            _urltoFiles(JSON.stringify(copyUrlImage)).then(data => {
              _transfer_variable("synchronizeTime", nowString()).then(res => {
                _transfer_variable("synchronizeVersion", version).then(res => {
                  // progress += progressOneStep;
                  // dialogProgress.setProgress(progress);
                  synchronizeSuccess();
                });
              });
            });
          } else {
            _transfer_variable("synchronizeTime", nowString()).then(res => {
              _transfer_variable("synchronizeVersion", version).then(res => {
                // progress += progressOneStep;
                // dialogProgress.setProgress(progress);
                synchronizeSuccess();
              });
            });
          }
        }

        // 上傳離線資料
        function DBUpLoad() {
          console.log('syncDateTime', syncDateTime);
          const tidySql = apiTidy("getUpServiceSales", {
            'syncDateTime': syncDateTime
          });
          console.log('getUpServiceSales SQL:', tidySql);
          _selectSQLite(tidySql).then(data => {
            let sqlData = JSON.parse(data.resData);
            uploadList["service_sales"] = sqlData;
            const tidySql = apiTidy("getUpServiceSaleTimes", {
              'syncDateTime': syncDateTime
            });
            _selectSQLite(tidySql).then(data => {
              let sqlData = JSON.parse(data.resData);
              uploadList["service_sale_times"] = sqlData;
              const tidySql = apiTidy("getUpServiceSaleStaffs", {
                'syncDateTime': syncDateTime
              });
              _selectSQLite(tidySql).then(data => {
                let sqlData = JSON.parse(data.resData);
                uploadList["service_sale_staffs"] = sqlData;
                const tidySql = apiTidy("getUpServiceSaleCuatomerFeedbacks", {
                  'syncDateTime': syncDateTime
                });
                _selectSQLite(tidySql).then(data => {
                  let sqlData = JSON.parse(data.resData);
                  uploadList["service_sale_cuatomer_feedbacks"] = sqlData;
                  const tidySql = apiTidy("getUpServiceSaleCuatomerFeedbacks", {
                    'syncDateTime': syncDateTime
                  });
                  _selectSQLite(tidySql).then(data => {
                    let sqlData = JSON.parse(data.resData);
                    uploadList["service_sale_cuatomer_feedbacks"] = sqlData;
                    const tidySql = apiTidy("getUpServiceSaleCuatomerFeedbackFiles", {
                      'syncDateTime': syncDateTime
                    });
                    _selectSQLite(tidySql).then(data => {
                      let sqlData = JSON.parse(data.resData);
                      uploadList["service_sale_cuatomer_feedback_files"] = sqlData;
                      const tidySql = apiTidy("getUpServiceMachines", {
                        'syncDateTime': syncDateTime
                      });
                      _selectSQLite(tidySql).then(data => {
                        let sqlData = JSON.parse(data.resData);
                        uploadList["service_machines"] = sqlData;
                        const tidySql = apiTidy("getUpServiceMachineStatuses", {
                          'syncDateTime': syncDateTime
                        });
                        _selectSQLite(tidySql).then(data => {
                          let sqlData = JSON.parse(data.resData);
                          uploadList["service_machine_statuses"] = sqlData;
                          const tidySql = apiTidy("getUpServiceMachineOthers", {
                            'syncDateTime': syncDateTime
                          });
                          _selectSQLite(tidySql).then(data => {
                            let sqlData = JSON.parse(data.resData);
                            uploadList["service_machine_others"] = sqlData;
                            const tidySql = apiTidy("getUpServiceMachineFittings", {
                              'syncDateTime': syncDateTime
                            });
                            _selectSQLite(tidySql).then(data => {
                              let sqlData = JSON.parse(data.resData);
                              uploadList["service_machine_fittings"] = sqlData;
                              const tidySql = apiTidy("getUpServiceMachineCourseTimes", {
                                'syncDateTime': syncDateTime
                              });
                              _selectSQLite(tidySql).then(data => {
                                let sqlData = JSON.parse(data.resData);
                                uploadList["service_machine_course_times"] = sqlData;
                                const tidySql = apiTidy("getUpServiceMachineCourseStudents", {
                                  'syncDateTime': syncDateTime
                                });
                                _selectSQLite(tidySql).then(data => {
                                  let sqlData = JSON.parse(data.resData);
                                  uploadList["service_machine_course_students"] = sqlData;
                                  const tidySql = apiTidy("getUpServiceMachineCoursePlans", {
                                    'syncDateTime': syncDateTime
                                  });
                                  _selectSQLite(tidySql).then(data => {
                                    let sqlData = JSON.parse(data.resData);
                                    uploadList["service_machine_course_plans"] = sqlData;
                                    const tidySql = apiTidy("getUpServiceMachineCoursePlanFiles", {
                                      'syncDateTime': syncDateTime
                                    });
                                    _selectSQLite(tidySql).then(data => {
                                      let sqlData = JSON.parse(data.resData);
                                      uploadList["service_machine_course_plan_files"] = sqlData;
                                      const tidySql = apiTidy("getUpServiceMachineProblems", {
                                        'syncDateTime': syncDateTime
                                      });
                                      _selectSQLite(tidySql).then(data => {
                                        let sqlData = JSON.parse(data.resData);
                                        uploadList["service_machine_problems"] = sqlData;
                                        const tidySql = apiTidy("getUpServiceMachineProblemTimes", {
                                          'syncDateTime': syncDateTime
                                        });
                                        _selectSQLite(tidySql).then(data => {
                                          let sqlData = JSON.parse(data.resData);
                                          uploadList["service_machine_problem_times"] = sqlData;
                                          const tidySql = apiTidy("getUpServiceMachineProblemTimeFiles", {
                                            'syncDateTime': syncDateTime
                                          });
                                          _selectSQLite(tidySql).then(data => {
                                            let sqlData = JSON.parse(data.resData);
                                            uploadList["service_machine_problem_time_files"] = sqlData;
                                            const tidySql = apiTidy("getUpServiceMachineBasics", {
                                              'syncDateTime': syncDateTime
                                            });
                                            _selectSQLite(tidySql).then(data => {
                                              let sqlData = JSON.parse(data.resData);
                                              uploadList["service_machine_basics"] = sqlData;
                                              const tidySql = apiTidy("getUpServiceMachineBasicYarns", {
                                                'syncDateTime': syncDateTime
                                              });
                                              _selectSQLite(tidySql).then(data => {
                                                let sqlData = JSON.parse(data.resData);
                                                uploadList["service_machine_basic_yarns"] = sqlData;
                                                const tidySql = apiTidy("getUpServiceMachineBasicFeeders", {
                                                  'syncDateTime': syncDateTime
                                                });
                                                _selectSQLite(tidySql).then(data => {
                                                  let sqlData = JSON.parse(data.resData);
                                                  uploadList["service_machine_basic_feeders"] = sqlData;
                                                  const tidySql = apiTidy("getUpServiceMachineArrangements", {
                                                    'syncDateTime': syncDateTime
                                                  });
                                                  _selectSQLite(tidySql).then(data => {
                                                    let sqlData = JSON.parse(data.resData);
                                                    uploadList["service_machine_arrangements"] = sqlData;
                                                    const tidySql = apiTidy("getUpServiceMachineArrangementOther", {
                                                      'syncDateTime': syncDateTime
                                                    });
                                                    _selectSQLite(tidySql).then(data => {
                                                      let sqlData = JSON.parse(data.resData);
                                                      uploadList["service_machine_arrangement_other"] = sqlData;
                                                      const tidySql = apiTidy("getUpServiceMachineArrangementFile", {
                                                        'syncDateTime': syncDateTime
                                                      });
                                                      _selectSQLite(tidySql).then(data => {
                                                        let sqlData = JSON.parse(data.resData);
                                                        uploadList["service_machine_arrangement_file"] = sqlData;
                                                        DBUpLoadNext();
                                                      });
                                                    });
                                                  });
                                                });
                                              });
                                            });
                                          });
                                        });
                                      });
                                    });
                                  });
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        }
        function DBUpLoadNext() {
          // console.log('uploadList',uploadList);
          OfflineDS.upLoadOfflineData({
            'offLineData': JSON.stringify(uploadList),
            'syncDateTime': syncDateTime
          }).then(res => {
            const {
              onSuccess,
              onFail
            } = ajax200Res(res);
            onSuccess(({
              res,
              data,
              msg,
              defaultAlert
            }) => {
              $.each(data.content.downloadFileList, function (key, item) {
                downloadFileList.push(item);
              });
              _progressDialogChange(1, 1);
              _progressDialogStart(ProgressText, t('synchronizeImage'));
              // progress += progressOneStep;
              // dialogProgress.setProgress(progress);
              // dialogProgress.setText(t('synchronizeImage'));
              // oriDialogProgressText = t('synchronizeImage');
              DBUpLoadFile();
            });
            onFail(({
              res,
              data,
              msg,
              defaultAlert
            }) => {
              synchronizeFail();
            });
          });
        }
        function DBUpLoadFile() {
          // console.log('downloadFileList',downloadFileList);
          if (downloadFileList !== undefined && downloadFileList.length > 0) {
            const baseUrl = window.location.origin + window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/') + 1) + "api/uploadFileNew";
            _offLineFileToDB(JSON.stringify(downloadFileList), baseUrl).then(data => {
              if (data.resCode == 1) {
                DBUpLoadFileNext();
              } else {
                synchronizeFail();
              }
            });
          } else {
            DBUpLoadFileNext();
          }
          function DBUpLoadFileNext() {
            _progressDialogChange(1, 1);
            _progressDialogStart(ProgressText, t('downloadOfflineFile'));
            // progress += progressOneStep;
            // dialogProgress.setProgress(progress);
            // dialogProgress.setText(t('downloadOfflineFile'));
            // oriDialogProgressText = t('downloadOfflineFile');
            offLineFileUpdate();
          }
        }
        function synchronizeFail() {
          _progressDialogStop();
          // dialogProgresStop();
          // dialogProgress.close();
          if (selectItem == 1) {
            _alert_custom(t('hint'), t('downloadFail'), function () {});
          } else {
            _alert_custom(t('hint'), t('synchronizeFail'), function () {});
          }
        }
        function synchronizeSuccess() {
          _progressDialogStop();
          // dialogProgresStop();
          // dialogProgress.close();
          if (selectItem == 1) {
            _alert_custom(t('hint'), t('downloadSuccess'), function () {
              init();
            });
          } else {
            _alert_custom(t('hint'), t('synchronizeSuccess'), function () {
              init();
            });
          }
        }
        function dialogProgresStart() {
          dialogProgressIng = setInterval(function () {
            synchronizing();
          }, 500);
        }
        function dialogProgresStop() {
          clearInterval(dialogProgressIng);
        }
        function synchronizing() {
          console.log('觸發時間', nowString());
          var dialogProgressText = dialogProgress.params.text;
          var letters = dialogProgressText.split(".");
          var letterLength = letters.length - 1;
          var lastDialogProgressText = oriDialogProgressText;
          var aaa = letterLength % 3;
          for (let index = 0; index <= aaa; index++) {
            lastDialogProgressText += ".";
          }
          dialogProgress.setText(lastDialogProgressText);
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_f7_icon = _resolveComponent("f7-icon");
      const _component_f7_button = _resolveComponent("f7-button");
      const _component_f7_nav_left = _resolveComponent("f7-nav-left");
      const _component_f7_nav_title = _resolveComponent("f7-nav-title");
      const _component_f7_link = _resolveComponent("f7-link");
      const _component_f7_nav_right = _resolveComponent("f7-nav-right");
      const _component_f7_navbar = _resolveComponent("f7-navbar");
      const _component_HomeBaseInput = __unplugin_components_0;
      const _component_f7_badge = _resolveComponent("f7-badge");
      const _component_f7_block = _resolveComponent("f7-block");
      const _component_CompanyCard = __unplugin_components_1;
      const _component_f7_fab = _resolveComponent("f7-fab");
      const _component_BaseCalendar = __unplugin_components_2;
      const _component_f7_block_title = _resolveComponent("f7-block-title");
      const _component_f7_list_item = _resolveComponent("f7-list-item");
      const _component_f7_list = _resolveComponent("f7-list");
      const _component_f7_sheet = _resolveComponent("f7-sheet");
      const _component_f7_page = _resolveComponent("f7-page");
      return _openBlock(), _createBlock(_component_f7_page, {
        class: "p-index"
      }, {
        default: _withCtx(() => [_createVNode(_component_f7_navbar, null, {
          default: _withCtx(() => [_createVNode(_component_f7_nav_left, null, {
            default: _withCtx(() => [!_unref(authInfo).offLine ? (_openBlock(), _createBlock(_component_f7_button, {
              key: 0,
              onClick: synchronizeData,
              outline: "",
              round: "",
              small: "",
              color: "white",
              style: {
                "padding": "0 15px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_f7_icon, {
                icon: "icon-repeat",
                style: {
                  "margin-right": "5px"
                }
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('synchronize')), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_f7_nav_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('salesOrder')), 1)]),
            _: 1
          }), _createVNode(_component_f7_nav_right, null, {
            default: _withCtx(() => [_createVNode(_component_f7_link, {
              icon: "icon-menu",
              color: "white",
              onclick: reLoadStaff,
              style: {
                "width": "34px"
              }
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_f7_block, {
          class: "m-0 w-full",
          style: {
            "padding": "10px 15px 15px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_HomeBaseInput, {
            name: "search",
            onBlurEven: init,
            placeholder: _ctx.$t('pleaseEnterHome'),
            modelValue: _unref(cData).title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(cData).title = $event),
            class: _normalizeClass(["small", {
              'placeholder-small': ['id', 'uz', 'es', 'vn'].includes(_unref(locale))
            }])
          }, {
            before: _withCtx(() => [_createVNode(_component_f7_icon, {
              icon: "icon-search",
              size: "18px",
              color: "gray",
              style: {
                "margin-right": "10px"
              }
            })]),
            _: 1
          }, 8, ["placeholder", "modelValue", "class"]), _createElementVNode("button", {
            onClick: openCalendar
          }, [_createVNode(_component_f7_icon, {
            icon: "icon-date",
            size: "20px",
            color: "primary"
          }, {
            default: _withCtx(() => [_unref(searchBadge).calendar ? (_openBlock(), _createBlock(_component_f7_badge, {
              key: 0,
              color: "orange"
            })) : _createCommentVNode("", true)]),
            _: 1
          })]), _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = $event => _unref(filter).isOpened = true)
          }, [_createVNode(_component_f7_icon, {
            icon: "icon-filter",
            size: "20px",
            color: "primary"
          }, {
            default: _withCtx(() => [_unref(searchBadge).filter ? (_openBlock(), _createBlock(_component_f7_badge, {
              key: 0,
              color: "orange"
            })) : _createCommentVNode("", true)]),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_f7_block, {
          class: "m-0 p-0 page-wrap"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cData).list, item => {
            return _openBlock(), _createBlock(_component_CompanyCard, {
              data: item,
              status: item.type
            }, null, 8, ["data", "status"]);
          }), 256))])]),
          _: 1
        }), _createVNode(_component_f7_fab, {
          position: "right-bottom",
          href: "/add_company/0"
        }, {
          default: _withCtx(() => [_createVNode(_component_f7_icon, {
            icon: "icon-add",
            size: "24px"
          })]),
          _: 1
        }), (_openBlock(), _createBlock(_component_BaseCalendar, {
          style: {
            "display": "none"
          },
          ref_key: "datepicker",
          ref: datepicker,
          modelValue: _unref(calendar).date,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(calendar).date = $event),
          "calendar-params": _unref(calendar).calendarParams,
          onSend: init,
          key: _unref(locale)
        }, null, 8, ["modelValue", "calendar-params"])), _createVNode(_component_f7_sheet, {
          class: "custom-sheet",
          opened: _unref(filter).isOpened,
          "onUpdate:opened": _cache[10] || (_cache[10] = $event => _unref(filter).isOpened = $event),
          backdrop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_f7_block, {
            class: "header"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('searchFilter')), 1), _createVNode(_component_f7_link, {
              class: "close-btn",
              icon: "icon-close",
              "sheet-close": ""
            })]),
            _: 1
          }), _createVNode(_component_f7_block_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('machineSpecifications')), 1)]),
            _: 1
          }), _createVNode(_component_f7_block, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
              type: "text",
              style: {
                "width": "70%"
              },
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(filter).specification_one = $event),
              maxlength: "18",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_one]]), _withDirectives(_createElementVNode("input", {
              type: "text",
              style: {
                "width": "30%"
              },
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(filter).specification_two = $event),
              maxlength: "4",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_two]])]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(filter).specification_three = $event),
              maxlength: "2",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_three]]), _createTextVNode(" \" "), _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(filter).specification_g = $event),
              maxlength: "2",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_g]]), _createTextVNode(" G "), _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(filter).specification_f = $event),
              maxlength: "3",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_f]]), _createTextVNode(" F "), _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(filter).specification_t = $event),
              maxlength: "4",
              onInput: focusNextInput
            }, null, 544), [[_vModelText, _unref(filter).specification_t]]), _createTextVNode(" T ")])])]),
            _: 1
          }), _createVNode(_component_f7_block_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('processingStatus')), 1)]),
            _: 1
          }), _createVNode(_component_f7_list, {
            class: "choose-button-wrap"
          }, {
            default: _withCtx(() => [_createVNode(_component_f7_list_item, {
              checkbox: "",
              title: _ctx.$t('processing'),
              "checkbox-icon": "end",
              checked: _unref(filter).status.includes('1'),
              value: "1",
              onChange: changeStatus
            }, null, 8, ["title", "checked"]), _createVNode(_component_f7_list_item, {
              checkbox: "",
              title: _ctx.$t('finish'),
              "checkbox-icon": "end",
              checked: _unref(filter).status.includes('2'),
              value: "2",
              onChange: changeStatus
            }, null, 8, ["title", "checked"]), _createVNode(_component_f7_list_item, {
              checkbox: "",
              title: _ctx.$t('waitCountermeasures'),
              "checkbox-icon": "end",
              checked: _unref(filter).status.includes('3'),
              value: "3",
              onChange: changeStatus
            }, null, 8, ["title", "checked"])]),
            _: 1
          }), _createVNode(_component_f7_block, {
            class: "footer"
          }, {
            default: _withCtx(() => [_createVNode(_component_f7_button, {
              class: "w-full",
              onclick: filterReset,
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)]),
              _: 1
            }), _createVNode(_component_f7_button, {
              class: "w-full",
              onClick: _cache[9] || (_cache[9] = $event => {
                _unref(filter).isOpened = false;
                init();
              }),
              fill: ""
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('submit')), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["opened"])]),
        _: 1
      });
    };
  }
};